import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 26 26"
    {...props}
  >
    <rect width={23.809} height={23.809} x={1.273} y={1.026} rx={4.5} />
    <rect
      width={2.205}
      height={11.245}
      x={12.415}
      y={7.308}
      fill="currentColor"
      rx={1.103}
    />
    <rect
      width={2.205}
      height={11.245}
      x={19.141}
      y={11.828}
      fill="currentColor"
      rx={1.103}
      transform="rotate(90 19.14 11.828)"
    />
  </svg>
);
export default SvgPlusOutlined;
